/** Permisos operativos del CRM: solo los asignados al rol/usuario (sin bypass por isAdmin). */

export function userIsCrmAdmin(user) {
  return Boolean(user?.isAdmin);
}

export function userHasCrmPermission(user, permissionCode) {
  if (!user || !permissionCode) return false;
  const perms = Array.isArray(user.permissions) ? user.permissions : [];
  return perms.includes(permissionCode);
}

export function userHasAnyCrmPermission(user, permissionCodes) {
  if (!user || !Array.isArray(permissionCodes) || !permissionCodes.length) return false;
  const perms = Array.isArray(user.permissions) ? user.permissions : [];
  return permissionCodes.some((code) => perms.includes(code));
}

export function canSeeCrmNavItem(user, item) {
  if (!item) return false;
  if (item.adminOnly && !userIsCrmAdmin(user)) return false;
  if (!item.permission && !item.permissionAnyOf?.length) return true;
  if (!user || !Array.isArray(user.permissions)) return false;
  if (Array.isArray(item.permissionAnyOf) && item.permissionAnyOf.length) {
    return userHasAnyCrmPermission(user, item.permissionAnyOf);
  }
  return userHasCrmPermission(user, item.permission);
}

export function canAccessCrmRoute(user, { permission, anyOfPermissions, adminOnly } = {}) {
  if (!user) return false;
  if (adminOnly && !userIsCrmAdmin(user)) return false;
  const codes = [
    ...(permission ? [permission] : []),
    ...(Array.isArray(anyOfPermissions) ? anyOfPermissions : [])
  ];
  if (!codes.length) return true;
  return codes.some((code) => userHasCrmPermission(user, code));
}
